import React from 'react';
import Chart from 'react-apexcharts';
import { ApexOptions } from 'apexcharts';
import './styles.css';

interface PieChartData {
  series: number[];
  labels?: string[];
}

interface PieChartConfig {
  donut?: boolean;
  donutSize?: string;
  showLabels?: boolean;
  showLegend?: boolean;
  legendPosition?: 'left' | 'right' | 'top' | 'bottom';
  colors?: string[];
  formatter?: (val: number, opts?: any) => string;
  customTooltip?: (val: number, opts?: any) => string;
}

interface PieChartProps {
  data: PieChartData;
  config?: PieChartConfig;
  title?: string;
  description?: string;
  height?: number | string;
  width?: number | string;
}

const PieChartComponent: React.FC<PieChartProps> = ({
  data,
  config = {},
  title,
  description,
  height = 350,
  width = '100%'
}) => {

  // Garante que todos os valores da série são floats
  const floatSeries = data.series.map(Number);

  const defaultConfig: PieChartConfig = {
    donut: true,
    donutSize: '65%',
    showLabels: true,
    showLegend: true,
    legendPosition: 'right',
    colors: [
      '#1E2D3F',  // Azul escuro
      '#2E415C',  // Azul médio
      '#4F7CAC',  // Azul claro
      '#00BCD4',  // Ciano
      '#76B7B2',  // Verde suave
      '#EDC948',  // Amarelo ouro
      '#B07AA1'   // Roxo suave
    ],
    formatter: (val) => `${val.toFixed(1)}%`,
  };

  const mergedConfig = { ...config, ...defaultConfig };
  const options: ApexOptions = {
    chart: {
      type: 'donut',
    },
    labels: data.labels,
    colors: mergedConfig.colors,
    plotOptions: {
      pie: {
        donut: {
          size: mergedConfig.donut ? mergedConfig.donutSize : '0%',
        },
      },
    },
    dataLabels: {
      enabled: mergedConfig.showLabels,
      formatter: mergedConfig.formatter,
      style: {
        fontSize: '12px',
        fontFamily: 'Arial, sans-serif',
      },
      dropShadow: {
        enabled: false,
      },
    },
    legend: {
      position: mergedConfig.legendPosition,
      fontSize: '14px',
      fontFamily: 'Arial, sans-serif',
      markers: {
        size: 12,
      },
    },
    tooltip: {
      enabled: true,
      y: {
        formatter: mergedConfig.customTooltip || function(val) {
          return val.toLocaleString('pt-BR', { 
            style: 'currency', 
            currency: 'BRL',
            minimumFractionDigits: 2,
            maximumFractionDigits: 2
          });
        },
      },
    },
    responsive: [{
      breakpoint: 768,
      options: {
        chart: {
          width: '100%',
        },
        legend: {
          position: 'bottom',
        },
      },
    }],
  };

  return (
    <div className="pie-chart-container">
      {title && <h3 className="pie-chart-title">{title}</h3>}
      {description && <p className="pie-chart-description">{description}</p>}
      
      <div className="chart-wrapper">
        <Chart
          options={options}
          series={floatSeries}
          type="donut"
          width={width}
          height={height}
        />
      </div>
    </div>
  );
};

export default PieChartComponent;